import axios from "axios";
import AuthService from "../login/auth.service";
// import { transferencias } from "../../components/generico/utils/UrlAPI";

import { basaSipacoop, transferencias } from "../../components/generico/utils/UrlAPI";

class SolicitarPinTransaccionalService {
  async solicitarPin(_pin) {

    var data = JSON.stringify({
      pin: _pin,
      canal: "WEB"
      // cedulaSocio: AuthService.getSocio().numeroCedula.trim(),
    });

    var config = {
      method: "post",
      // url: "solicitar-pin/?access_token=" + AuthService.getCurrentToken(),
      url: transferencias + "pines/solicitar",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + AuthService.getCurrentToken(),
      },
      data: data,
    };
    return await axios(config);
  }

  async obtenerterminosCondiciones() {
    var config = {
      method: "get",
      url:
        basaSipacoop + "acuerdos/obtener",
      // "obtener-terminos-condiciones/?access_token=" +
      // AuthService.getCurrentToken() +
      // "&dato=" +
      // AuthService.getSocio().numeroSocio.trim(),
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + AuthService.getCurrentToken(),
      },
    };

    return await axios(config);
  }

  async aceptarTerminos(_id) {
    //console.log(_id);
    var data = JSON.stringify({
      idTexto: _id,
      canal: "WEB"
      // numeroSocio: AuthService.getSocio().numeroSocio.trim(),
    });

    var config = {
      method: "post",
      url: basaSipacoop + "acuerdos/aceptar",
      // url: "aceptar-terminos/?access_token=" + AuthService.getCurrentToken(),
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + AuthService.getCurrentToken(),
      },
      data: data,
    };

    return await axios(config);
  }


}
export default new SolicitarPinTransaccionalService();
